exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol.portraitFrame-breadcrumb{background-color:inherit;padding:4px 15px}h1.portraitFrame-pageHeader{margin-left:5px;margin-top:5px;margin-bottom:0}.portraitFrame-header-container{height:63px}.portraitFrame-body-container{height:calc(100% - 63px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--3-1!../node_modules/postcss-loader/lib!../node_modules/sass-loader/lib/loader.js!./assets/scss/portraitFrame.scss
// module id = 707
// module chunks = 0